export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9087.df086f50.jpg";